import type { Product } from '../types/product';
import { fetchAllProducts } from './productsApi';
import { newestMerchandise } from '../utils/latestProducts';

/**
 * El catálogo completo (mercancía, del más nuevo al más viejo) sobre el que se busca.
 * Son pocos cientos de artículos: se piden una vez y cada tecla filtra aquí mismo
 * (src/utils/productSearch.ts). Lo comparten el buscador del header, las sugerencias
 * y el catálogo, y se renueva a los pocos minutos para no mostrar stock viejo.
 */
const TTL_MS = 5 * 60_000;

let cache: { at: number; promise: Promise<Product[]> } | null = null;

export function loadSearchCatalog(force = false): Promise<Product[]> {
  if (force || !cache || Date.now() - cache.at > TTL_MS) {
    const promise = fetchAllProducts().then(newestMerchandise);
    const entry = { at: Date.now(), promise };
    cache = entry;
    // Si falla, la próxima búsqueda vuelve a intentarlo en vez de heredar el error
    promise.catch(() => {
      if (cache === entry) cache = null;
    });
  }
  return cache.promise;
}
